<template>
<v-container>
    <!-- Hero Banner -->
    <v-sheet class="hero-banner rounded-xl mb-6 pa-6 pa-md-8" dark elevation="4">
      <v-row align="center" no-gutters>
        <v-col cols="12" md="8" class="d-flex align-center">
          <v-avatar size="64" color="white" class="mr-4 elevation-3">
            <v-img v-if="school && school.logo" :src="school.logo"></v-img>
            <v-icon v-else size="34" color="primary">mdi-view-dashboard</v-icon>
          </v-avatar>
          <div>
            <div class="text-h5 font-weight-bold">{{ greeting }}{{ school && school.name ? ', ' + school.name : '' }}!</div>
            <div class="hero-subtitle">Pick a module below to get started.</div>
          </div>
        </v-col>
        <v-col cols="12" md="4" class="text-md-right mt-4 mt-md-0">
          <v-chip class="ma-1" color="white" outlined label>
            <v-icon left small>mdi-shield-key</v-icon>{{ tokensLeft }} Tokens
          </v-chip>
          <v-btn class="ma-1 rounded-pill font-weight-bold text-none" color="white" outlined small @click="buyTokenModal = !buyTokenModal">
            <v-icon left small>mdi-cart-plus</v-icon> Top Up
          </v-btn>
        </v-col>
      </v-row>
    </v-sheet>

    <!-- Modules -->
    <div class="text-overline grey--text font-weight-bold mb-2 px-1">Modules</div>
    <v-row>
        <v-col cols="12" sm="6" md="4" v-for="item in items" :key="item.title">
            <v-card class="module-card rounded-xl fill-height" elevation="2">
                <v-card-text class="text-center pa-6">
                    <v-avatar size="64" :color="item.color" class="mb-4 module-icon">
                        <v-icon size="32" color="white">{{item.icon}}</v-icon>
                    </v-avatar>
                    <div class="text-h6 font-weight-bold black--text mb-1">{{item.title}}</div>
                    <p class="caption grey--text mb-4 module-subtitle">{{item.subtitle}}</p>
                    <v-btn block rounded :disabled="item.disabled" class="font-weight-bold text-none" :color="item.color" dark :to="{ name: item.routerName }">
                        {{item.btn_msg}}
                        <v-icon right small>mdi-arrow-right</v-icon>
                    </v-btn>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>

    <!-- Quick Actions -->
    <div class="text-overline grey--text font-weight-bold mb-2 mt-8 px-1">Quick Actions</div>
    <v-row>
        <v-col cols="12" sm="6" md="4">
            <v-card class="module-card rounded-xl fill-height" elevation="2" @click="updateSchoolModal = !updateSchoolModal">
                <v-card-text class="text-center pa-6">
                    <v-avatar size="64" color="red" class="mb-4 module-icon">
                        <v-icon size="32" color="white">mdi-cog</v-icon>
                    </v-avatar>
                    <div class="text-h6 font-weight-bold black--text mb-1">School Settings</div>
                    <p class="caption grey--text mb-4 module-subtitle">Set Logo, Update School Info</p>
                    <v-btn block rounded outlined color="red" class="font-weight-bold text-none">Update</v-btn>
                </v-card-text>
            </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="4">
            <v-card class="module-card rounded-xl fill-height" elevation="2" @click="buyTokenModal = !buyTokenModal">
                <v-card-text class="text-center pa-6">
                    <v-avatar size="64" color="purple" class="mb-4 module-icon">
                        <v-icon size="32" color="white">mdi-shield-key</v-icon>
                    </v-avatar>
                    <div class="text-h6 font-weight-bold black--text mb-1">Buy MYSCH Tokens</div>
                    <p class="caption grey--text mb-4 module-subtitle">Get Tokens for giveaway price</p>
                    <v-btn block rounded outlined color="purple" class="font-weight-bold text-none">Purchase</v-btn>
                </v-card-text>
            </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="4">
            <v-card class="module-card rounded-xl fill-height" elevation="2" @click="newsModal = !newsModal">
                <v-card-text class="text-center pa-6">
                    <v-avatar size="64" color="amber darken-1" class="mb-4 module-icon">
                        <v-icon size="32" color="white">mdi-newspaper</v-icon>
                    </v-avatar>
                    <div class="text-h6 font-weight-bold black--text mb-1">MYSCH Updates</div>
                    <p class="caption grey--text mb-4 module-subtitle">Latest News / Info from MYSCH</p>
                    <v-btn block rounded outlined color="amber darken-2" class="font-weight-bold text-none">See Updates</v-btn>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>

    <update-school-info v-if="updateSchoolModal"/>
    <buy-token-modal v-if="buyTokenModal"/>
    <news-modal v-if="newsModal"/>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import BuyTokenModal from '../../components/BuyTokenModal.vue';
import NewsModal from '../../components/NewsModal.vue';
import UpdateSchoolInfo from '../../components/UpdateSchoolInfo.vue';
  export default {
    name: 'Dashboard',
    components: {
        UpdateSchoolInfo,
        BuyTokenModal,
        NewsModal,
    },
    mounted() {
       if (!this.authToken) {
           this.$router.push({name: 'Login'})
       }
    },
    computed: {
        ...mapState({
            tokensLeft: (state) => state.tokensLeft,
        }),
        greeting() {
            const hour = new Date().getHours();
            if (hour < 12) return 'Good morning';
            if (hour < 17) return 'Good afternoon';
            return 'Good evening';
        },
    },
    data: () => ({
        updateSchoolModal: false,
        buyTokenModal: false,
        newsModal: false,
        school: localStorage.getItem('school') ? JSON.parse(localStorage.getItem('school')) : null,
        authToken:sessionStorage.getItem('authToken') ?? null,
        items: [
            {
                title: 'Basic School Setup',
                subtitle: 'Session, Class, Students, Subjects, Grades',
                icon: 'mdi-tools', // Icon representing results or analytics
                routerName: 'SetupDashboard',
                color: '#00755E',
                disabled: false,
                btn_msg: 'Configure'
            },
            {
                title: 'Results Module',
                subtitle: 'Enter Scores, View/Print Results',
                icon: 'mdi-chart-box-outline', // Icon representing results or analytics
                routerName: 'ResultsDashboard',
                color: '#004F98',
                disabled: false,
                btn_msg: 'Continue'
            },
            {
                title: 'Multi-User Access',
                subtitle: 'Generate PINS and Access KEYS to Teachers, Parents and Students',
                icon: 'mdi-account-key', // Icon representing results or analytics
                routerName: 'GenerateAccessTokens',
                color: '#E0115F',
                disabled: false,
                btn_msg: 'Generate'
            },
            {
                title: 'Attendance Module',
                subtitle: 'Record Student & Teacher attendance',
                icon: 'mdi-account-check-outline', // Represents attendance or verification
                routerName: 'AttendanceDashboard',
                color: 'secondary',
                disabled: true,
                btn_msg: 'Soon'
            },
            // {
            //     title: 'Experiments Simulation Module',
            //     subtitle: 'For your students/pupils to simulate science experiments',
            //     icon: 'mdi-chemical-weapon', // Represents financial/accounting tasks
            //     routerName: '',
            //     color: 'info',
            //     disabled: true,
            //     btn_msg: 'Coming Soon'
            // },

            // {
            //     title: 'Flashcards Module',
            //     subtitle: 'Generate colorful learning cards',
            //     icon: 'mdi-cards-outline', // Icon for flashcards
            //     routerName: 'FlashCardsDashboard',
            //     color: 'primary',
            //     disabled: true,
            //     btn_msg: 'Coming Soon'
            // },
            // {
            //     title: 'AI Generated Module',
            //     subtitle: 'Generate image, video and text contents',
            //     icon: 'mdi-robot-outline', // Represents AI or automation
            //     routerName: '',
            //     color: 'info',
            //     disabled: true,
            //     btn_msg: 'Coming Soon'
            // },
            {
                title: 'Accounting Module',
                subtitle: 'Manage school fees, dues, Salaries',
                icon: 'mdi-currency-usd', // Represents financial/accounting tasks
                routerName: '',
                color: 'info',
                disabled: true,
                btn_msg: 'Soon'
            },
            {
                title: 'School Website Module',
                subtitle: 'Create and Update your custom school website',
                icon: 'mdi-web-box', // Icon for lesson notes or notebooks
                routerName: 'SchoolWebsiteDashboard',
                color: 'warning',
                disabled: true,
                btn_msg: 'Soon'
            },
            // {
            //     title: 'Lesson Notes Module',
            //     subtitle: 'Create Notes, AI Generated',
            //     icon: 'mdi-notebook-outline', // Icon for lesson notes or notebooks
            //     routerName: 'LessonNotesDashboard',
            //     color: 'warning',
            //     disabled: true,
            //     btn_msg: 'Coming Soon'
            // },
        ]

    }),
  }
</script>

<style scoped>
.hero-banner {
  background: linear-gradient(135deg, #4527a0 0%, #1e3c72 100%);
}
.hero-subtitle {
  opacity: 0.85;
  font-size: 0.95rem;
  margin-top: 2px;
}
.module-card {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;
}
.module-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.1) !important;
}
.module-icon {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
}
.module-subtitle {
  min-height: 40px;
}
.text-none {
  text-transform: none !important;
}
</style>
